<template>
    <div class="wrapper">
        <div v-if="mode === MAKE_SCHEDULE_MODE.DEFAULT" style="padding: 20px 20px 0px; padding-bottom: 10px;">
            <div @click="close" style="margin-top: 10px; display: flex; align-items: center; position: relative">
                <img :src="require('@/assets/img/black_x_btn_new.png')" style="width: 20px" />
                <div v-if="isModifyMemberTalkSchedule" style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700">스케줄 수정하기</div>
                <div v-else-if="isOpen" style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700">스케줄 피드 {{ scheduleIdx ? '수정하기' : '만들기' }}</div>
                <div v-else style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700">스케줄 만들기</div>
            </div>
        </div>
        <div v-else style="padding: 0 12px; padding-bottom: 16px; border-bottom: 1px solid #f5f5f5;">
            <div @click="close" style="display: flex; align-items: center; position: relative">
                <img :src="require('@/assets/img/recent_x_btn.png')" style="width: 42px" />
                <div style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700">스케줄 피드 만들기</div>
            </div>
        </div>
        <div ref="main_wrap" class="main_wrap">
            <div class="step1">
                <div class="input_text title">
                    <div class="common_text">제목</div>
                    <input @input="handleTitleLength" v-model="makeScheduleInfo.title" placeholder="스케줄 이름을 입력해주세요" class="text_area" type="text">
                    <div class="count_text">{{ makeScheduleInfo.title.length }} / 40</div>
                </div>
                <div v-if="isOpen" class="input_text contents">
                    <div class="common_text">소개</div>
                    <input @input="handleIntroLength" v-model="makeScheduleInfo.contents" placeholder="스케줄을 소개해주세요" class="text_area" type="text">
                    <div class="count_text">{{ makeScheduleInfo.contents.length }} / 200</div>
                </div>
                <div v-else class="input_text contents">
                    <div class="common_text">소개</div>
                    <div style="position: relative;">
                        <Transition v-if="!isJoin" name="fade">
                            <div v-if="isShowPopup" class="guide_box" style="position: absolute;">
                                <div class="triangle" style=""></div>
                                <div style="display: flex; align-items: center; gap: 10px; justify-content: space-between;">
                                    <div style="flex-shrink: 0; font-weight: 700; font-size: 12px; color: #606060;">사커하우 추천 문구</div>
                                    <div @click="closePopup" style="width: 20px; height: 20px; display: flex; align-items: center; justify-content: center;">
                                        <img style="width: 8px;" :src="require('@/assets/img/reco_popup.png')" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div style="font-size: 12px; color: var(--color-main); font-weight: 500; line-height: 17px; white-space: nowrap;">“내일 경기 용병 한 분 구합니다.”<br>“골키퍼 한 분 모십니다”</div>
                                </div>
                            </div>
                        </Transition>
                        <textarea style="line-height: 20px;" @input="handleIntroLength" v-model="makeScheduleInfo.contents" placeholder="스케줄을 설명해주세요" class="text_area" name="" id="" cols="30" rows="10"></textarea>
                    </div>
                    <div class="count_text">{{ makeScheduleInfo.contents.length }} / 500</div>
                </div>
            </div>
            <div v-if="!isJoin" class="step2">
                <div style="margin-bottom: 20px;">
                    <div class="common_text">테마</div>
                    <div style="display: flex; margin-top: 4px; gap: 8px; flex-wrap: wrap;">
                        <div style="white-space: nowrap;" v-for="each, i in theme" :key="i">
                            <MercenaryModalBtn :isActive="each === makeScheduleInfo.theme" :clickEvent="() => { setTheme(each) }" :btnName="each"></MercenaryModalBtn>
                        </div>
                    </div>
                    <div class="only_one">1개만 선택할 수 있습니다.</div>
                </div>
            </div>
            <div class="step3">
                <div class="common_text">일정</div>
                <div class="schedule_box">
                    <div @click="showCalendar" class="select_day common">
                        <img :src="require('@/assets/img/make_sche_calendar.png')" alt="">
                        <div class="title">일정</div>
                        <div v-if="isShowDate" class="select_sche">{{ settingJoinDate }}</div>
                        <div v-else-if="isShowRepeatDay" class="select_sche">{{ settingRepeatDay }}</div>
                        <div v-else class="select_sche">선택</div>
                        <div class="arrow_img_wrap">
                            <img :src="require('@/assets/images/mypage/ico-move.png')" alt="">
                        </div>
                    </div>
                    <div :style="{ paddingBottom: isJoin ? '8px' : '' }" class="time_picker common">
                        <img :src="require('@/assets/img/time_picker.png')" alt="">
                        <div class="title">시간</div>
                        <div class="time_box">
                            <div @click="showTimeSelector('begin')" :class="isAllDay ? 'disable_time_box' : 'select_time'">{{ makeScheduleInfo.schedule_hour_begin }}</div>
                            <div style="color: #808080">~</div>
                            <div @click="showTimeSelector('end')" :class="isAllDay ? 'disable_time_box' : 'select_time'">{{ makeScheduleInfo.schedule_hour_end }}</div>
                        </div>
                    </div>
                    <div v-if="isJoin" style="border-top: 1px solid #ebebeb; padding-top: 8px; display: flex; justify-content: end; align-items: center;">
                        <div style="font-weight: 500; font-size: 14px;">하루종일</div>
                        <CommonSwitch :switchClickEvent="setAllDay" :changeWidth="'60px'" :isOn="isAllDay"></CommonSwitch>
                    </div>
                </div>
            </div>
            <div class="step4">
                <div class="common_text">장소</div>
                <div class="common_box">
                    <div>
                        <NewPlaceSearchSelector v-if="isDataLoaded" :isModify="isModify" :placeInfo="makeScheduleInfo.placeInfo" :resetInfo="resetInfo" :detect-select="detectRegionSelect" style="flex:1; "></NewPlaceSearchSelector>
                        <NewPlaceSearchSelector v-if="!isModify" :isModify="isModify" :placeInfo="makeScheduleInfo.placeInfo" :resetInfo="resetInfo" :detect-select="detectRegionSelect" style="flex:1; "></NewPlaceSearchSelector>
                    </div>
                </div>
            </div>
            <div v-if="!isJoin" class="step5">
                <div class="common_text">모집 인원</div>
                <NewPlusMinusBtn :saveRecruit="saveRecruit" :isDuplicate="isModify" :duplicateCnt="makeScheduleInfo.recruitCnt"></NewPlusMinusBtn>
                <div class="recruit_text">최대 10명까지 모집할 수 있습니다.</div>
            </div>
            <div v-if="!isJoin" class="step6">
                <div class="common_text">비용 형태</div>
                <div :class="makeScheduleInfo.fee ? 'on_border' : ''">
                    <div @click="setPayFee('pay')" :class="makeScheduleInfo.fee ? 'on_pay_fee' : 'off_pay_fee'" class="common_box pay_type">
                        <div class="pay_img_wrap">
                            <img :src="require('@/assets/img/new_pay_pee.png')" alt="">
                        </div>
                        <div class="select_box">
                            <div class="title">참가 비용 받음</div>
                            <div class="contents">함께하는 용병도 같이 돈을 냅니다. <span>(구장 대관, 경기 운영 등)</span></div>
                        </div>
                    </div>
                    <div v-if="makeScheduleInfo.fee" class="common_box pay_box">
                        <div class="common_text">참가 비용</div>
                        <div class="pay_input_wrap">
                            <input @keyup="comma" ref="feeInput" v-model="makeScheduleInfo.enterFee" class="pay_input" type="tel">
                            <div class="won">원</div>
                        </div>
                        <div class="pay_contents">참가 비용은 앱 내에서 결제가 진행되지 않으며,<br>용병에게 직접 참가비를 받아야 합니다.</div>
                    </div>
                </div>
                <div @click="setPayFee('free')" :class="!makeScheduleInfo.fee && makeScheduleInfo.fee !== null ? 'on_border_free' : ''" class="common_box pay_type">
                    <div class="pay_img_wrap">
                        <img :src="require('@/assets/img/new_free_pee.png')" alt="">
                    </div>
                    <div class="select_box">
                        <div class="title">참가비 없음</div>
                        <div class="contents">함께하는 용병은 돈을 내지 않습니다.</div>
                    </div>
                </div>
                <div class="one_select_text">1개만 선택할 수 있습니다.</div>
            </div>
        </div>
        <div class="make_schedule_wrap">
            <div v-if="isModify" @click="makeSchedule" class="make_schedule">스케줄 수정 완료</div>
            <div v-else-if="isJoin" @click="makeMemberTalkSchedule" class="make_schedule">스케줄 만들기</div>
            <div v-else @click="makeSchedule" class="make_schedule">스케줄 만들기</div>
        </div>
        <div style="position: relative; z-index: 100;">
            <TimeSelectorPopupNew :is-show-time-selector="isShowTimeSelectorBegin" :hide="() => { isShowTimeSelectorBegin = false }" :start-time="makeScheduleInfo.schedule_hour_begin" :complete-action="setTimeBegin"></TimeSelectorPopupNew>
        </div>
        <div style="position: relative; z-index: 100;">
            <TimeSelectorPopupNew :is-show-time-selector="isShowTimeSelectorEnd" :hide="() => { isShowTimeSelectorEnd = false }" :start-time="makeScheduleInfo.schedule_hour_end" :complete-action="setTimeEnd"></TimeSelectorPopupNew>
        </div>
        <div style="position: relative; z-index: 100;">
            <ScheduleSettings :isJoin="isJoin" :joinDate="saveJoinDate" :isRepeat="isRepeat" :isModify="isModify" :repeatDay="repeatDay" :resetRepeatDay="resetRepeatDay" :setRepeatDay="setRepeatDay" :resetJoinDate="resetJoinDate" :detectSelectDate="detectSelectDate" :isOpenCalendar="isOpenCalendar" :closeCalendar="closeCalendar"></ScheduleSettings>
        </div>
        <div style="position: relative; z-index: 100;">
            <SelectMatchType :setMatchType="setMatchType" :isSelectMatch="isSelectMatch" :closeSelectMatch="closeSelectMatch" :selectMatchType="selectMatchType" :matchType="makeScheduleInfo.game_type"></SelectMatchType>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import MercenaryModalBtn from '../common/MercenaryModalBtn';
import NewPlaceSearchSelector from '../common/NewPlaceSearchSelector';
import NewPlusMinusBtn from '../common/NewPlusMinusBtn';
import TimeSelectorPopupNew from '../common/TimeSelectorPopupNew';
// import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ScheduleSettings from './ScheduleSettings';
import ResponseCode from '../../ResponseCode';
import { MEMBER_TYPE, DUES_TYPE, TOAST_TYPE, FORM_MODE } from '../../Constants';
import SelectMatchType from '@/components/common/SelectMatchType';
import CommonSwitch from '@/components/common/CommonSwitch';

export const MAKE_SCHEDULE_MODE = {
    DEFAULT: 0,
    POPUP: 1,
};

export default {
    components: { MercenaryModalBtn, NewPlaceSearchSelector, NewPlusMinusBtn, TimeSelectorPopupNew, ScheduleSettings, SelectMatchType, CommonSwitch },
    name: "NewMakeMercenarySchedule",
    props: {
        scheduleIdx: {
            type: [String, Number],
            default: ''
        },
        isRepeat: {
            type: Boolean,
            default: false
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        isJoin: {
            type: Boolean,
            default: false
        },
        joinIdx: {
            type: [String, Number],
            default: ''
        },
        isModifyMemberTalkSchedule: {
            type: Boolean,
            default: false
        },
        isOpen: {
            type: Boolean,
            default: false
        },
        mode: {
            type: Number,
            default: 0
        }
    },
    computed: {
        settingJoinDate() {
            let transJoinDate;

            transJoinDate = this.makeScheduleInfo.join_date.split('-')[0] + '년 ' + this.makeScheduleInfo.join_date.split('-')[1] + '월 ' + this.makeScheduleInfo.join_date.split('-')[2] + '일 ' + this.dayOfWeek + '요일'

            return transJoinDate
        },
        settingRepeatDay() {
            let transRepeatDay

            transRepeatDay = '매주 ' + this.repeatDay

            return transRepeatDay
        }
    },
    data() {
        return {
            theme: ['스터디', '단체레슨', '매치', '경기관람', '기타'],
            DUES_TYPE: DUES_TYPE,
            MAKE_SCHEDULE_MODE: MAKE_SCHEDULE_MODE,
            makeScheduleInfo: {
                title: '',
                contents: '',
                theme: '',
                fee: null,
                enterFee: '',
                placeInfo: {},
                recruitCnt: 1,
                schedule_hour_begin: '',
                schedule_hour_end: '',
                join_date: '',
                game_type: ''
            },
            isShowTimeSelectorBegin: false,
            isShowTimeSelectorEnd: false,
            isOpenCalendar: false,
            isShowDate: false,
            isShowRepeatDay: false,
            dayOfWeek: '',
            repeatDay: null,
            MEMBER_TYPE: MEMBER_TYPE,
            isModify: false,
            modifyCnt: 0,
            isDataLoaded: false,
            saveJoinDate: '',
            isShowPopup: false,
            isSelectMatch: false,
            isAllDay: false
        }
    },
    methods: {
        async makeMemberTalkSchedule() {
            if (this.makeScheduleInfo.title === '') {
                this.$GlobalStore.showAlert('제목을 입력해주세요.')
                return false
            }

            if (this.makeScheduleInfo.contents === '') {
                this.$GlobalStore.showAlert('소개를 입력해주세요.')
                return false
            }

            if (this.makeScheduleInfo.join_date === '' && this.repeatDay === null) {
                this.$GlobalStore.showAlert('일정을 선택해주세요.')
                return false
            }

            if (this.makeScheduleInfo.schedule_hour_begin === '' || this.makeScheduleInfo.schedule_hour_end === '') {
                this.$GlobalStore.showAlert('시간을 설정해주세요.')
                return false
            }

            if (Object.keys(this.makeScheduleInfo.placeInfo).length === 0) {
                this.$GlobalStore.showAlert('장소를 설정해주세요.')
                return false
            }

            this.makeScheduleInfo.insert = 'insert'
            this.makeScheduleInfo.joinIdx = this.joinIdx
            this.makeScheduleInfo.recruitCnt = parseInt(this.makeScheduleInfo.recruitCnt) + 1
            this.$GlobalStore.showProgress()
            const formData = new FormData()
            const dataObjects = [
                { key: 'mode', value: 'insert' },
                { key: 'title', value: 'title' },
                { key: 'contents', value: 'contents' },
                { key: 'join_date', value: 'join_date' },
                { key: 'begin_time', value: 'schedule_hour_begin' },
                { key: 'end_time', value: 'schedule_hour_end' },
                { key: 'join_idx', value: 'joinIdx' },
            ]

            dataObjects.forEach(item => {
                formData.append(item.key, this.makeScheduleInfo[item.value])
            })

            formData.append('max_cnt', 10000)
            formData.append('is_open', '0');
            formData.append('place_name', this.makeScheduleInfo.placeInfo.name);
            formData.append('place_id', this.makeScheduleInfo.placeInfo.id);
            formData.append('gps_latitude', this.makeScheduleInfo.placeInfo.gps_latitude);
            formData.append('gps_longitude', this.makeScheduleInfo.placeInfo.gps_longitude);
            formData.append('place_address', this.makeScheduleInfo.placeInfo.address);

            const res = await this.$Axios.post('/api/join/schedule/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.closeLastModal()
                this.completeAction();
                this.$GlobalStore.showToastVer2('스케줄을 만들었어요', TOAST_TYPE.MAKESCHEDULE)
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        setAllDay() {
            this.isAllDay = !this.isAllDay
            if (this.isAllDay) {
                this.makeScheduleInfo.schedule_hour_begin = '00:00'
                this.makeScheduleInfo.schedule_hour_end = '23:59'
            } else {
                this.makeScheduleInfo.schedule_hour_begin = ''
                this.makeScheduleInfo.schedule_hour_end = ''
            }
        },
        handleIntroLength() {
            if (this.makeScheduleInfo.contents.length > 500) {
                this.makeScheduleInfo.contents = this.makeScheduleInfo.contents.slice(0, 500)
            }
        },
        handleTitleLength() {
            if (this.makeScheduleInfo.title.length > 40) {
                this.makeScheduleInfo.title = this.makeScheduleInfo.title.slice(0, 40)
            }
        },
        setMatchType() {
            if (this.makeScheduleInfo.game_type === '') {
                alert('경기 형태를 선택해주세요')
                return
            }
            this.isSelectMatch = false
        },
        selectMatchType(match) {
            this.makeScheduleInfo.game_type = match
        },
        closeSelectMatch() {
            this.isSelectMatch = false
            this.makeScheduleInfo.theme = ''
            this.makeScheduleInfo.game_type = ''
        },
        closePopup() {
            this.isShowPopup = false
        },
        resetInfo() {
            this.makeScheduleInfo.placeInfo = {}
        },
        resetRepeatDay() {
            this.isShowRepeatDay = false
            this.repeatDay = null
        },
        setRepeatDay(day) {
            this.repeatDay = day
            this.isShowRepeatDay = true
        },
        resetJoinDate() {
            this.makeScheduleInfo.join_date = ''
            this.isShowDate = false
        },
        detectSelectDate(date, day_str) {
            this.dayOfWeek = day_str
            this.makeScheduleInfo.join_date = date
            this.isShowDate = true
        },
        closeCalendar() {
            this.isOpenCalendar = false
        },
        showCalendar() {
            this.isOpenCalendar = true
        },
        showTimeSelector(type) {
            if (type === 'begin') {
                this.isShowTimeSelectorBegin = true
            } else {
                this.isShowTimeSelectorEnd = true
            }
        },
        setTimeBegin(startHour) {
            this.makeScheduleInfo.schedule_hour_begin = startHour
            const end_time = moment(startHour, 'HH:mm').add(1, 'hours').format('HH:mm')
            this.makeScheduleInfo.schedule_hour_end = end_time
            // this.calcTimeTaken()
        },
        setTimeEnd(endHour) {
            this.makeScheduleInfo.schedule_hour_end = endHour
            // this.calcTimeTaken()
        },
        checkMakeSchedule() {
            if (this.makeScheduleInfo.title === '') {
                this.$GlobalStore.showAlert('제목을 입력해주세요.')
                return false
            }

            if (this.makeScheduleInfo.contents === '') {
                this.$GlobalStore.showAlert('소개를 입력해주세요.')
                return false
            }

            if (this.makeScheduleInfo.theme === '') {
                this.$GlobalStore.showAlert('테마를 선택해주세요.')
                return false
            }

            if (this.makeScheduleInfo.join_date === '' && this.repeatDay === null) {
                this.$GlobalStore.showAlert('일정을 선택해주세요.')
                return false
            }

            if (this.makeScheduleInfo.schedule_hour_begin === '' || this.makeScheduleInfo.schedule_hour_end === '') {
                this.$GlobalStore.showAlert('시간을 설정해주세요.')
                return false
            }

            if (Object.keys(this.makeScheduleInfo.placeInfo).length === 0) {
                this.$GlobalStore.showAlert('장소를 설정해주세요.')
                return false
            }

            if (this.makeScheduleInfo.fee === null) {
                this.$GlobalStore.showAlert('비용 형태를 선택해주세요.')
                return false
            }

            if (this.makeScheduleInfo.fee === true && this.makeScheduleInfo.enterFee === '') {
                this.$GlobalStore.showAlert('참가 비용을 설정해주세요.')
                return false
            }

            return true
        },
        async makeSchedule() {
            if (!this.checkMakeSchedule()) {
                return
            }
            this.$GlobalStore.showProgress()
            const formData = new FormData()
            if (this.isModify) {
                this.makeScheduleInfo.insert = 'update'
            } else {
                this.makeScheduleInfo.insert = 'insert'
            }

            if (this.isModifyMemberTalkSchedule) {
                this.makeScheduleInfo.recruitCnt = 10000
                this.makeScheduleInfo.enterFee = 0
            }

            this.makeScheduleInfo.recruitCnt = parseInt(this.makeScheduleInfo.recruitCnt) + 1

            // 참가비 있음 = 1, 참가비 없음 = 3
            const dataObjects = [
                { key: 'mode', value: 'insert' },
                { key: 'title', value: 'title' },
                { key: 'contents', value: 'contents' },
                { key: 'theme', value: 'theme' },
                { key: 'join_date', value: 'join_date' },
                { key: 'begin_time', value: 'schedule_hour_begin' },
                { key: 'dues_type', value: 'fee' },
                { key: 'end_time', value: 'schedule_hour_end' },
                { key: 'max_cnt', value: 'recruitCnt' },
                { key: 'dues', value: 'enterFee' },
                // { key: 'game_type', value: 'game_type' },
                // { key: 'join_idx', value: 'joinIdx' },
            ]

            dataObjects.forEach(item => {
                if (item.key === 'dues_type') {
                    if (this.makeScheduleInfo.fee) {
                        formData.append(item.key, 1)
                    } else {
                        formData.append(item.key, 3)
                    }
                } else {
                    formData.append(item.key, this.makeScheduleInfo[item.value])
                }
            })

            formData.append('place_name', this.makeScheduleInfo.placeInfo.name);
            formData.append('place_id', this.makeScheduleInfo.placeInfo.id);
            formData.append('gps_latitude', this.makeScheduleInfo.placeInfo.gps_latitude);
            formData.append('gps_longitude', this.makeScheduleInfo.placeInfo.gps_longitude);
            formData.append('place_address', this.makeScheduleInfo.placeInfo.address);
            formData.append('is_open', this.isOpen ? 1 : 0);

            if (this.repeatDay) {
                formData.append('repeat_day', this.repeatDay[0])
                formData.append('mercenary_schedule_idx', 0)
            }

            if (this.isModify && !this.isModifyMemberTalkSchedule) {
                formData.append('mercenary_schedule_idx', this.scheduleIdx)
            }

            let res;

            if (this.isModifyMemberTalkSchedule) {
                formData.append('join_schedule_idx', this.scheduleIdx)
                res = await this.$Axios.post('/api/join/schedule/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            } else if (this.isOpen) {
                formData.append('join_schedule_idx', this.scheduleIdx)
                formData.append('join_idx', this.joinIdx);
                res = await this.$Axios.post('/api/join/schedule/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            } else {
                res = this.repeatDay !== null ? await this.$Axios.post('/api/mercenary/schedule/repeat/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } }) : await this.$Axios.post('/api/mercenary/schedule/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            }


            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress()

                if (this.isOpen) {
                    this.completeAction();
                    this.$GlobalStore.closeLastModal();
                    this.$GlobalStore.addModal('MercenaryScheduleDetailPopup', {transitionName: '', isModalBackTransparent: true, schedule_idx : res.data.join_schedule_idx});
                    return;
                }

                if (this.isModify) {
                    this.$GlobalStore.closeLastModal()
                    if (this.isModifyMemberTalkSchedule) {
                        this.completeAction(FORM_MODE.UPDATE)
                    }
                    if (this.isRepeat) {
                        this.completeAction(true)
                    } else if (!this.isModifyMemberTalkSchedule) {
                        this.completeAction()
                    }
                } else {
                    this.$GlobalStore.closeSpliceModal('MakeJoinOrSchedule')
                    let mercenary_scout_member_idx = null;
                    let mercenary_scout_member_type = null;
                    const member_data = this.$GlobalStore.checkViewExist('ShowProfileCard');
                    if (member_data) {
                        mercenary_scout_member_idx = member_data.memberIdx;
                        mercenary_scout_member_type = MEMBER_TYPE.USER;
                    } else {
                        const coach_data = this.$GlobalStore.checkViewExist('ShowProfileCardCoach');
                        if (coach_data) {
                            mercenary_scout_member_idx = coach_data.coach_idx;
                            mercenary_scout_member_type = MEMBER_TYPE.COACH;
                        }
                    }
                    if (this.repeatDay) {
                        this.$GlobalStore.addModal('MercenarySchedule', { scheduleIdx: res.data.mercenary_schedule_idx, is_from_preview: true, mercenary_scout_member_idx: mercenary_scout_member_idx, mercenary_scout_member_type: mercenary_scout_member_type, isRepeat: true })
                    } else {
                        this.$GlobalStore.addModal('MercenarySchedule', { scheduleIdx: res.data.mercenary_schedule_idx, is_from_preview: true, mercenary_scout_member_idx: mercenary_scout_member_idx, mercenary_scout_member_type: mercenary_scout_member_type })
                    }
                }

            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg)
                this.$GlobalStore.hideProgress()
            }
        },
        setPayFee(type, isModify) {
            if (type === 'pay') {
                this.makeScheduleInfo.fee = true
                if (!isModify) {
                    this.$nextTick(() => {
                        this.$refs.feeInput.focus();
                    })
                }
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs.main_wrap.scrollTop = this.$refs.main_wrap.scrollHeight
                    }, 0);
                })
            } else {
                this.makeScheduleInfo.fee = false
                this.makeScheduleInfo.enterFee = '0'
            }

        },
        saveRecruit(cnt) {
            this.makeScheduleInfo.recruitCnt = cnt
        },
        close() {
            if (this.isModify || this.isModifyMemberTalkSchedule) {
                const html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">작성 중인 내용이 모두 사라집니다.<br>피드 수정을 중단하고 뒤로갈까요?</div>`;
                this.$GlobalStore.showConfirm(html, async () => {
                    this.$GlobalStore.closeLastModal()
                }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => {})

                // this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block; width:280px;">스케줄 수정하기를 종료하시겠습니까?</strong><br>작성하던 내용은 저장되지 않습니다.<br>그래도 종료하시겠습니까?', () => {
                //     this.$GlobalStore.closeLastModal()
                // }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
            } else if (this.isJoin || this.isOpen) {
                const html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">작성 중인 내용이 모두 사라집니다.<br>피드 만들기를 중단하고 뒤로갈까요?</div>`;
                this.$GlobalStore.showConfirm(html, async () => {
                    if (this.mode === MAKE_SCHEDULE_MODE.DEFAULT) {
                        this.$GlobalStore.closeLastModal()
                    } else {
                        this.completeAction()
                    }
                }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => {})

                // this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block; width:280px;">스케줄 만들기를 종료하시겠습니까?</strong><br>작성하던 내용은 저장되지 않습니다.<br>그래도 종료하시겠습니까?', () => {
                //     if (this.mode === MAKE_SCHEDULE_MODE.DEFAULT) {
                //         this.$GlobalStore.closeLastModal()
                //     } else {
                //         this.completeAction()
                //     }
                // }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
            } else {
                const html = `<div style="padding:20px 15px; color:#210F03; line-height: 20px; font-size:14px;">작성 중인 내용이 모두 사라집니다.<br>피드 만들기를 중단하고 뒤로갈까요?</div>`;
                this.$GlobalStore.showConfirm(html, async () => {
                    if (this.mode === MAKE_SCHEDULE_MODE.DEFAULT) {
                        this.$GlobalStore.closeSpliceModal('MakeJoinOrSchedule')
                    } else {
                        this.completeAction()
                    }
                }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => {})
                // this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block;">스케줄 만들기를 종료하시겠습니까?</strong><br>작성하던 내용은 저장되지 않습니다.<br>그래도 종료하시겠습니까?', () => {
                //     if (this.mode === MAKE_SCHEDULE_MODE.DEFAULT) {
                //         this.$GlobalStore.closeSpliceModal('MakeJoinOrSchedule')
                //     } else {
                //         this.completeAction()
                //     }
                // }, '그만하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
            }

        },
        async getScheduleDetail() {
            const parameters = {}
            if (this.isModifyMemberTalkSchedule || this.isOpen) {
                parameters.join_schedule_idx = this.scheduleIdx
            } else {
                parameters.mercenary_schedule_idx = this.scheduleIdx;
            }

            const res = (this.isModifyMemberTalkSchedule || this.isOpen) ? await this.$Axios.get('/api/join/schedule/detail', { params: parameters }) : await this.$Axios.get('/api/mercenary/schedule/detail', { params: parameters });

            const result = (this.isModifyMemberTalkSchedule || this.isOpen) ? res.data.join_schedules : res.data.mercenary_schedule

            this.makeScheduleInfo.title = result.title
            this.makeScheduleInfo.contents = result.contents
            this.makeScheduleInfo.theme = result.theme
            this.makeScheduleInfo.recruitCnt = result.max_cnt

            if (this.isOpen) {
                if (result.dues === '.0000') {
                    this.setPayFee('free', true)
                } else {
                    this.makeScheduleInfo.enterFee = this.$options.filters.comma(result.dues);
                    this.setPayFee('pay', true)
                }
            } else if (result.dues_type == DUES_TYPE.DEFAULT || result.dues_type == DUES_TYPE.FREE) {
                this.setPayFee('free', true)
            } else {
                this.makeScheduleInfo.enterFee = result.dues
                this.setPayFee('pay', true)
            }
            this.makeScheduleInfo.join_date = result.join_date
            this.dayOfWeek = this.getDayOfWeeks(this.makeScheduleInfo.join_date)
            this.isShowDate = true
            this.makeScheduleInfo.schedule_hour_begin = result.begin_time
            this.makeScheduleInfo.schedule_hour_end = result.end_time
            this.makeScheduleInfo.placeInfo = {
                address: result.address,
                display_str: result.place_name,
                gps_latitude: result.gps_latitude,
                gps_longitude: result.gps_longitude,
                id: result.place_id,
                name: result.place_name,
                phone: '',
            }
            this.isDataLoaded = true
            // this.saveRecruit(this.makeScheduleInfo.recruitCnt)

        },
        getDayOfWeeks(date) {
            const dateString = date
            const dateMoment = moment(dateString, 'YYYY-MM-DD')
            const weekday = dateMoment.format('dddd')

            return weekday[0]
        },
        // async getRepeatScheduleDetail() {
        //     const parameters = {}
        //     parameters.mercenary_schedule_idx = this.scheduleIdx
        //     const res = await this.$Axios.get('/api/mercenary/schedule/repeat/detail', { params: parameters });
        //
        //     const result = res.data.mercenary_schedule
        //
        //     this.makeScheduleInfo.title = result.title
        //     this.makeScheduleInfo.contents = result.contents
        //     this.makeScheduleInfo.theme = result.theme
        //     this.makeScheduleInfo.recruitCnt = result.max_cnt
        //     if (result.dues_type == DUES_TYPE.DEFAULT || result.dues_type == DUES_TYPE.FREE) {
        //         this.setPayFee('free', true)
        //     } else {
        //         this.makeScheduleInfo.enterFee = parseInt(result.dues).toLocaleString('ko-kr')
        //         this.setPayFee('pay', true)
        //     }
        //     this.repeatDay = result.repeat_day + '요일'
        //     this.isShowRepeatDay = true
        //     this.makeScheduleInfo.schedule_hour_begin = result.begin_time
        //     this.makeScheduleInfo.schedule_hour_end = result.end_time
        //     this.makeScheduleInfo.placeInfo = {
        //         address: result.address,
        //         display_str: result.place_name,
        //         gps_latitude: result.gps_latitude,
        //         gps_longitude: result.gps_longitude,
        //         id: result.place_id,
        //         name: result.place_name,
        //         phone: '',
        //     }
        //     this.isDataLoaded = true
        //
        // },
        setTheme(theme) {
            if (theme === '매치') {
                this.isSelectMatch = true
            } else {
                this.makeScheduleInfo.game_type = ''
            }
            this.makeScheduleInfo.theme = theme
        },
        detectRegionSelect(region) {
            this.makeScheduleInfo.placeInfo = region
        },
        comma(e) {
            const target = e.currentTarget;
            const rgx1 = /[^\d]/g;
            const rgx2 = /(\d+)(\d{3})/;
            let num = target.value.replace(rgx1, "");

            while (rgx2.test(num)) num = num.replace(rgx2, '$1' + ',' + '$2');

            this.makeScheduleInfo.enterFee = num
        },
    },
    created() {
        if (this.$Util.isShowDefaultSettings()) {
            return
        }
        this.makeMemberTalkSchedule = this.$Once(this.makeMemberTalkSchedule);
        this.makeSchedule = this.$Once(this.makeSchedule);

        if (this.scheduleIdx !== '') {
            this.isModify = true
            // if (this.isRepeat) {
            //     this.getRepeatScheduleDetail()
            // } else {
            this.getScheduleDetail()
            // }
        }

        setTimeout(() => {
            if (!this.isOpen) this.isShowPopup = true
        }, 1500)
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.guide_box {
    width: 185px;
    height: 67px;
    display: flex;
    flex-direction: column;
    top: 44px;
    justify-content: space-between;
    padding: 8px;
    padding-bottom: 12px;
    border-radius: 10px;
    background: #fff;
    position: absolute;
    left: 31%;
    transform: translateX(-50%);
    z-index: 10;
    /* opacity: 1; */
    /* transition: all 0.5s; */
}

.triangle {
    border-top: 0px solid transparent;
    border-left: 0px solid transparent;
    border-right: 30px solid transparent;
    border-bottom: 20px solid #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    content: "";
    position: absolute;
    top: -14px;
    left: 20%;
    transform: translateX(-50%);
}

.wrapper {
    display: flex;
    flex-direction: column;
}

.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
}

.make_schedule_wrap {
    height: 93px;
}

.make_schedule_wrap .make_schedule {
    border-radius: 12px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background-color: #210f03;
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 12px;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
}

.main_wrap {
    padding: 20px;
    flex: 1;
    overflow-y: scroll;
    scroll-behavior: smooth;

}

.step1 {
    margin-bottom: 35px;
}

.common_text {
    font-weight: 700;
    font-size: 12px;
    margin-bottom: 8px;
}

.input_text.title {
    margin-bottom: 25px;
}

.input_text input::placeholder {
    font-weight: 700;
    color: #bbbbbb;
}

.input_text textarea::placeholder {
    font-size: 14px;
    color: #bbbbbb;
}

.input_text .text_area {
    outline: none;
    border: none;
    width: 100%;
    background-color: #f5f5f5;
    border-radius: 12px;
    padding: 12px;
}

.input_text .count_text {
    float: right;
    margin-top: 6px;
    color: #bbbbbb;
    font-size: 12px;
    font-weight: 700;
}

.only_one {
    font-size: 12px;
    color: #606060;
    margin-top: 6px;
    font-weight: 500;
}

.step2 {
    margin-bottom: 16px;
}

.step3 {
    margin-bottom: 16px;
}

.schedule_box {
    background-color: #f5f5f5;
    border-radius: 12px;
    padding: 10px;
    font-weight: 500;
}


.schedule_box .common {
    display: flex;
    align-items: center;
    gap: 8px;
}

.schedule_box .time_picker .time_box {
    display: flex;
    align-items: center;
}

.common .title {
    font-size: 14px;
    white-space: nowrap;
}

.select_day img {
    width: 14px;
}

.time_picker img {
    width: 14px;
}

.arrow_img_wrap {
    position: absolute;
    right: 18px;
}

.arrow_img_wrap img {
    transform: rotate(90deg);
    width: 9px;
}

.select_day {
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 8px;
    position: relative;
}

.select_day .select_sche {
    background-color: #fff;
    height: 44px;
    border-radius: 4px;
    line-height: 44px;
    text-align: center;
    font-size: 14px;
    width: 100%;
}

.time_picker {
    padding-top: 8px;
}

.time_box {
    flex: 1;
    display: flex;
    gap: 4px;
}

.time_box .select_time {
    flex: 1;
    height: 44px;
    background-color: #fff;
    border-radius: 4px;
    line-height: 44px;
    text-align: center;
}

.time_box .disable_time_box {
    flex: 1;
    height: 44px;
    background-color: #ebebeb;
    border-radius: 4px;
    line-height: 44px;
    text-align: center;
    pointer-events: none;
    color: #ebebeb;
}

.step4 {
    margin-bottom: 16px;
}

.step5 {
    margin-bottom: 16px;
}

.step5 .recruit_text {
    font-size: 12px;
    font-weight: 500;
    color: #606060;
    margin-top: 6px;
}

.step6 {}

.step6 .pay_type {}

.pay_img_wrap img {
    width: 20px;
}

.pay_type {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
}

.select_box .title {
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 4px;
}

.select_box .contents {
    font-size: 10px;
    font-weight: 500;
    color: #606060;
}

.one_select_text {
    font-weight: 500;
    font-size: 12px;
    color: #606060;
    margin-top: 6px;
}

.pay_box {
    border-top: 1px solid #ebebeb;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.pay_box .pay_input {
    border: none;
    outline: none;
    width: 100%;
    border-radius: 5px;
    padding: 10px;
    padding-right: 30px;
}

.pay_input_wrap {
    position: relative;
}

.pay_input_wrap .won {
    position: absolute;
    font-weight: 500;
    color: #606060;
    top: 50%;
    transform: translateY(-50%);
    right: 12px;
}

.pay_contents {
    font-size: 12px;
    font-weight: 500;
    color: #808080;
    line-height: 17px;
    margin-top: 4px;
}

.on_pay_fee {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.off_pay_fee {
    margin-bottom: 12px;
}

.on_border {
    border: 1px solid var(--color-main);
    margin-bottom: 12px;
    border-radius: 12px;
}

.on_border_free {
    border: 1px solid var(--color-main);
    border-radius: 12px;
}
</style>
